import PlayerQrCodeForm from "./player-qr-code-form";
export default PlayerQrCodeForm;
